export default __webpack_public_path__ + "static/media/fortypercent.69bf1e8e.gif";